import {AfterViewInit, Component, ElementRef, OnInit} from '@angular/core';

declare var gtag;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'Bounce Pages';
  isScan = true;
  mode = 'scan';
  imageDetail = {};
  constructor(private elementRef: ElementRef) {
  }

  showPage(evt): void{
    this.isScan = false;
    this.imageDetail = evt;
  }

  showScanPage(evt): void{
    this.mode = evt;
    this.isScan = true;
  }

  ngAfterViewInit(): void {
  }

  ngOnInit(): void {
    const innerHeight = window.innerHeight;
    this.elementRef.nativeElement.style.setProperty(
      '--iframe-height', `${innerHeight * 0.75}px`
    );
  }
}
